var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00049 4.16254C8.56194 4.16254 9.82772 5.42836 9.82772 6.98981C9.82772 8.55125 8.56194 9.81707 7.00049 9.81707C5.43904 9.81707 4.17319 8.55125 4.17319 6.98981C4.17319 5.42836 5.43904 4.16254 7.00049 4.16254ZM7.37639 18.5888C18.5348 6.36031 12.7677 0.246094 7.00049 0.246094C1.23326 0.246094 -4.53385 6.36031 6.62459 18.5888C6.72447 18.6985 6.85209 18.7545 7.00049 18.7545C7.14873 18.7545 7.27658 18.6984 7.37639 18.5888Z",
    fill: "#0052FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationBlueIcon);
export default __webpack_public_path__ + "static/media/LocationBlueIcon.b3f56c759f3421ca21f407e3031cb929.svg";
export { ForwardRef as ReactComponent };